<template>
  <div class="list">
    <draggable
      tag="div"
      class="drag-container"
      ghost-class="sortable__ghost"
      group="list"
      :list="value"
      :force-fallback="true"
      :move="onGroupMove"
      @change="resortGroups"
    >
      <div v-for="group in value" :key="group.id" class="list-group" :data-fake="!group.id">
        <template v-if="!group.id">
          <div class="list-items">
            <draggable
              class="drag-container"
              ghost-class="sortable__ghost"
              group="item"
              :list="group.items"
              :force-fallback="true"
              @change="resortGroup($event, group)"
            >
              <div v-for="item in group.items" :key="item.id" class="list-item">
                <slot name="item" :item="item" />
              </div>
            </draggable>
          </div>
        </template>

        <template v-else>
          <div class="list-group__header">
            <slot name="group" :group="group" />
          </div>

          <slide-up-down :active="group.open || group.empty" :duration="400" class="list-group__items">
            <loader v-if="group.loading" :active="group.loading" height="38" class="list-group__loader" />

            <div v-else class="list-items">
              <draggable
                class="drag-container"
                ghost-class="sortable__ghost"
                group="item"
                :data-group="group.id"
                :list="group.items"
                :force-fallback="true"
                @change="resortGroup($event, group)"
              >
                <div v-for="item in group.items" :key="item.id" class="list-item">
                  <slot name="item" :item="item" :group="group" />
                </div>
              </draggable>
            </div>
          </slide-up-down>
        </template>
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import SlideUpDown from "vue-slide-up-down";
import Loader from "@/components/loader";

export default {
  components: { draggable, SlideUpDown, Loader },
  props: ["value"],

  created() {
    console.log(this.value);
  },

  methods: {
    onGroupMove(event) {
      const { draggedContext, relatedContext } = event;
      if (!draggedContext.element.id || !relatedContext.element.id) return false;
      return true;
    },

    resortGroups() {
      this.$emit("moveGroups", { groups: this.value.filter((group) => group.id) });
    },

    resortGroup(event, group) {
      if (event.added) {
        this.$emit("addItemToGroup", { group, item: event.added.element });
      } else if (event.removed) {
        this.$emit("removeItemFromGroup", { group, item: event.removed.element });
      } else if (event.moved) {
        this.$emit("moveItemsInGroup", { group, item: event.moved.element });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  &-group {
    &__items {
      padding-left: 16px;
    }
    &__loader {
      /deep/ .loader-icon {
        font-size: 22px;
      }
    }
  }

  .list-group + .list-group {
    margin-top: -1px;
  }

  .list-group + .list-group[data-fake] {
    margin-top: 15px;
  }

  .list-item {
    margin-top: -1px;
  }
}
</style>
